"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQLEditorMode = exports.CompletionItemInsertTextRule = exports.CompletionItemKind = exports.CompletionItemPriority = exports.SuggestionKind = exports.StatementPosition = exports.TokenType = exports.MacroType = exports.OperatorType = void 0;
var OperatorType;
(function (OperatorType) {
    OperatorType[OperatorType["Comparison"] = 0] = "Comparison";
    OperatorType[OperatorType["Logical"] = 1] = "Logical";
})(OperatorType = exports.OperatorType || (exports.OperatorType = {}));
var MacroType;
(function (MacroType) {
    MacroType[MacroType["Value"] = 0] = "Value";
    MacroType[MacroType["Filter"] = 1] = "Filter";
    MacroType[MacroType["Group"] = 2] = "Group";
    MacroType[MacroType["Column"] = 3] = "Column";
    MacroType[MacroType["Table"] = 4] = "Table";
})(MacroType = exports.MacroType || (exports.MacroType = {}));
var TokenType;
(function (TokenType) {
    TokenType["Parenthesis"] = "delimiter.parenthesis.sql";
    TokenType["Whitespace"] = "white.sql";
    TokenType["Keyword"] = "keyword.sql";
    TokenType["Delimiter"] = "delimiter.sql";
    TokenType["Operator"] = "operator.sql";
    TokenType["Identifier"] = "identifier.sql";
    TokenType["IdentifierQuote"] = "identifier.quote.sql";
    TokenType["Type"] = "type.sql";
    TokenType["Function"] = "predefined.sql";
    TokenType["Number"] = "number.sql";
    TokenType["String"] = "string.sql";
    TokenType["Variable"] = "variable.sql";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
var StatementPosition;
(function (StatementPosition) {
    StatementPosition["Unknown"] = "unknown";
    StatementPosition["SelectKeyword"] = "selectKeyword";
    StatementPosition["WithKeyword"] = "withKeyword";
    StatementPosition["AfterSelectKeyword"] = "afterSelectKeyword";
    StatementPosition["AfterSelectArguments"] = "afterSelectArguments";
    StatementPosition["AfterSelectFuncFirstArgument"] = "afterSelectFuncFirstArgument";
    StatementPosition["SelectAlias"] = "selectAlias";
    StatementPosition["AfterFromKeyword"] = "afterFromKeyword";
    StatementPosition["AfterTable"] = "afterTable";
    StatementPosition["SchemaFuncFirstArgument"] = "schemaFuncFirstArgument";
    StatementPosition["SchemaFuncExtraArgument"] = "schemaFuncExtraArgument";
    StatementPosition["FromKeyword"] = "fromKeyword";
    StatementPosition["AfterFrom"] = "afterFrom";
    StatementPosition["WhereKeyword"] = "whereKeyword";
    StatementPosition["WhereComparisonOperator"] = "whereComparisonOperator";
    StatementPosition["WhereValue"] = "whereValue";
    StatementPosition["AfterWhereFunctionArgument"] = "afterWhereFunctionArgument";
    StatementPosition["AfterGroupByFunctionArgument"] = "afterGroupByFunctionArgument";
    StatementPosition["AfterWhereValue"] = "afterWhereValue";
    StatementPosition["AfterGroupByKeywords"] = "afterGroupByKeywords";
    StatementPosition["AfterGroupBy"] = "afterGroupBy";
    StatementPosition["AfterOrderByKeywords"] = "afterOrderByKeywords";
    StatementPosition["AfterOrderByFunction"] = "afterOrderByFunction";
    StatementPosition["AfterOrderByDirection"] = "afterOrderByDirection";
    StatementPosition["AfterIsOperator"] = "afterIsOperator";
    StatementPosition["AfterIsNotOperator"] = "afterIsNotOperator";
    StatementPosition["AfterSchema"] = "afterSchema";
})(StatementPosition = exports.StatementPosition || (exports.StatementPosition = {}));
var SuggestionKind;
(function (SuggestionKind) {
    SuggestionKind["Schemas"] = "schemas";
    SuggestionKind["Tables"] = "tables";
    SuggestionKind["Columns"] = "columns";
    SuggestionKind["SelectKeyword"] = "selectKeyword";
    SuggestionKind["WithKeyword"] = "withKeyword";
    SuggestionKind["FunctionsWithArguments"] = "functionsWithArguments";
    SuggestionKind["FromKeyword"] = "fromKeyword";
    SuggestionKind["WhereKeyword"] = "whereKeyword";
    SuggestionKind["GroupByKeywords"] = "groupByKeywords";
    SuggestionKind["OrderByKeywords"] = "orderByKeywords";
    SuggestionKind["FunctionsWithoutArguments"] = "functionsWithoutArguments";
    SuggestionKind["LimitKeyword"] = "limitKeyword";
    SuggestionKind["SortOrderDirectionKeyword"] = "sortOrderDirectionKeyword";
    SuggestionKind["ComparisonOperators"] = "comparisonOperators";
    SuggestionKind["LogicalOperators"] = "logicalOperators";
    SuggestionKind["SelectMacro"] = "selectMacro";
    SuggestionKind["TableMacro"] = "tableMacro";
    SuggestionKind["FilterMacro"] = "filterMacro";
    SuggestionKind["GroupMacro"] = "groupMacro";
    SuggestionKind["BoolValues"] = "boolValues";
    SuggestionKind["NullValue"] = "nullValue";
    SuggestionKind["NotKeyword"] = "notKeyword";
    SuggestionKind["TemplateVariables"] = "templateVariables";
    SuggestionKind["StarWildCard"] = "starWildCard";
})(SuggestionKind = exports.SuggestionKind || (exports.SuggestionKind = {}));
// TODO: export from grafana/ui
var CompletionItemPriority;
(function (CompletionItemPriority) {
    CompletionItemPriority["High"] = "a";
    CompletionItemPriority["MediumHigh"] = "d";
    CompletionItemPriority["Medium"] = "g";
    CompletionItemPriority["MediumLow"] = "k";
    CompletionItemPriority["Low"] = "q";
})(CompletionItemPriority = exports.CompletionItemPriority || (exports.CompletionItemPriority = {}));
var CompletionItemKind;
(function (CompletionItemKind) {
    CompletionItemKind[CompletionItemKind["Method"] = 0] = "Method";
    CompletionItemKind[CompletionItemKind["Function"] = 1] = "Function";
    CompletionItemKind[CompletionItemKind["Constructor"] = 2] = "Constructor";
    CompletionItemKind[CompletionItemKind["Field"] = 3] = "Field";
    CompletionItemKind[CompletionItemKind["Variable"] = 4] = "Variable";
    CompletionItemKind[CompletionItemKind["Class"] = 5] = "Class";
    CompletionItemKind[CompletionItemKind["Struct"] = 6] = "Struct";
    CompletionItemKind[CompletionItemKind["Interface"] = 7] = "Interface";
    CompletionItemKind[CompletionItemKind["Module"] = 8] = "Module";
    CompletionItemKind[CompletionItemKind["Property"] = 9] = "Property";
    CompletionItemKind[CompletionItemKind["Event"] = 10] = "Event";
    CompletionItemKind[CompletionItemKind["Operator"] = 11] = "Operator";
    CompletionItemKind[CompletionItemKind["Unit"] = 12] = "Unit";
    CompletionItemKind[CompletionItemKind["Value"] = 13] = "Value";
    CompletionItemKind[CompletionItemKind["Constant"] = 14] = "Constant";
    CompletionItemKind[CompletionItemKind["Enum"] = 15] = "Enum";
    CompletionItemKind[CompletionItemKind["EnumMember"] = 16] = "EnumMember";
    CompletionItemKind[CompletionItemKind["Keyword"] = 17] = "Keyword";
    CompletionItemKind[CompletionItemKind["Text"] = 18] = "Text";
    CompletionItemKind[CompletionItemKind["Color"] = 19] = "Color";
    CompletionItemKind[CompletionItemKind["File"] = 20] = "File";
    CompletionItemKind[CompletionItemKind["Reference"] = 21] = "Reference";
    CompletionItemKind[CompletionItemKind["Customcolor"] = 22] = "Customcolor";
    CompletionItemKind[CompletionItemKind["Folder"] = 23] = "Folder";
    CompletionItemKind[CompletionItemKind["TypeParameter"] = 24] = "TypeParameter";
    CompletionItemKind[CompletionItemKind["User"] = 25] = "User";
    CompletionItemKind[CompletionItemKind["Issue"] = 26] = "Issue";
    CompletionItemKind[CompletionItemKind["Snippet"] = 27] = "Snippet";
})(CompletionItemKind = exports.CompletionItemKind || (exports.CompletionItemKind = {}));
var CompletionItemInsertTextRule;
(function (CompletionItemInsertTextRule) {
    CompletionItemInsertTextRule[CompletionItemInsertTextRule["KeepWhitespace"] = 1] = "KeepWhitespace";
    CompletionItemInsertTextRule[CompletionItemInsertTextRule["InsertAsSnippet"] = 4] = "InsertAsSnippet";
})(CompletionItemInsertTextRule = exports.CompletionItemInsertTextRule || (exports.CompletionItemInsertTextRule = {}));
var SQLEditorMode;
(function (SQLEditorMode) {
    SQLEditorMode["Builder"] = "builder";
    SQLEditorMode["Code"] = "code";
})(SQLEditorMode = exports.SQLEditorMode || (exports.SQLEditorMode = {}));
//# sourceMappingURL=types.js.map